import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/message.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/icon.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/placeholder.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/divider.css'
import styles from './styles.m.scss'
import './styles.scss'
import ReactHtmlParser from 'react-html-parser'
import { FetchErrorMessage } from 'components/fetchErrorMessage'
import { LocaleContext } from '../../contexts/locale'
import { MunicipalitySearch } from '@ta-interaktiv/react-municipality-search'
import { parseHostname } from '@ta-interaktiv/parse-hostname'
import { VoteBackendResponse } from 'types/voteBackendResponse'
import VotationResultsTable from 'components/votationResultsTable'
import clsx from 'clsx'
import Scrollchor from 'react-scrollchor'
import { ArticleTeasers } from '@ta-interaktiv/react-article-teasers'
import { Municipality } from 'types/municipalityChart'
// import DUMMYTEXTS from './de_main-run_1393572-2020-09-12.js'
import FeedbackMessage from '@ta-interaktiv/react-feedback-message'
import { ScrollToTopOnMount } from 'components/scrollToTop'
import LOCALES from './locales.js'
import csvjson from 'csvjson'

interface Props {
  municipalityId: string | null
  onMunicipalitySelection: (config: { GDENR: number }) => void
}

interface State {
  articleText: string | null
  texts: {
    federal: Array<string> | null
    cantonal: Array<string> | null
  }
  title: string
  errorMessage: string | null
  modules: Array<{ type: string; element: JSX.Element }>
  resultsTable: string | null
}

export class Article extends React.Component<Props, State> {
  static contextType = LocaleContext

  state = {
    articleText: null,
    texts: { federal: [], cantonal: [] },
    title: LOCALES.title[this.context],
    errorMessage: null,
    modules: [],
    resultsTable: null
  }

  currentLocale = this.context

  /**
   * Send some data to the datapipeline
   *
   * @param  bfs Commune UID
   */
  static sendToDataPipeline = (bfs: string) => {
    const BASE_URL = 'https://w.tda.io/b/votation'
    const ZIP = '?zip=' + bfs
    const url = BASE_URL + ZIP
    return window
      .fetch(url, {
        method: 'GET',
        mode: 'no-cors',
        credentials: 'include'
      })
      .then(response => {
        console.log(response)
      })
      .catch(error => {
        console.log(error)
      })
  }

  /**
   * Retrieves processed texts from initial wordsmith templates
   *
   * @param  bfs Commune UID
   * @param locale
   */
  getVoteText(bfs: string, locale: 'de' | 'fr') {
    const BASE_URL = 'https://vote-backend.tagesanzeiger.ch'
    const API_ENDPOINT = '/api/v2/gettext/'
    const endpoint = new URL(API_ENDPOINT + bfs, BASE_URL)
    endpoint.searchParams.append('votationdate', '09022020') // 27092020
    endpoint.searchParams.append('vote1', '')
    endpoint.searchParams.append('vote2', '')
    endpoint.searchParams.append('vote3', '')
    endpoint.searchParams.append('lang', locale)
    const url = endpoint

    // noinspection JSIgnoredPromiseFromCall
    Article.sendToDataPipeline(bfs)

    return window
      .fetch(url.href, {
        method: 'GET',
        mode: 'cors',
        cache: 'no-cache',
        headers: {
          'Content-Type': 'application/json; charset=utf-8'
        }
      })
      .then(response => {
        if (response.ok) {
          return response.json() as Promise<VoteBackendResponse>
        }

        // Dummy data

        /* const selectedDummyText =
          DUMMYTEXTS[+this.props.match.params.municipalityId - 1]
        return new Promise(resolve => {
          resolve({ content: selectedDummyText })
        }) as Promise<VoteBackendResponse> */

        //

        throw new Error(response.status + ': ' + response.statusText)
      })
  }

  handleError(error: Error) {
    this.setState({ errorMessage: error.message })
    console.group('Fetch Article')
    console.warn('Article could not be loaded')
    console.warn(error)
    console.groupEnd()
  }

  getVoteInfoDataCsv() {
    return fetch(
      `https://interaktiv.tagesanzeiger.ch/2020/atm-vote-data/graphdata_2020-09-27.csv`
    )
      .then(response => {
        return response.text()
      })
      .then(csv => {
        const csvData = csvjson.toObject(csv, {})
        const data = new Array<{ objectNumber: number; data: Municipality[] }>()
        const objects = new Array<{ objectNumber: number; key: string }>()

        Object.keys(csvData[0]).forEach(k => {
          const match = k.match(/(\d)_jastimmeninprozent/)
          if (match) {
            objects.push({
              objectNumber: +match[1],
              key: k
            })
          }
        })

        objects.forEach(o => {
          data.push({
            objectNumber: o.objectNumber,
            data: csvData.reduce((a, b) => {
              const res = +b[o.key]
              if (res) {
                return [
                  ...a,
                  {
                    canton: b.gdekt,
                    municipalityNumber: +b.bfs,
                    municipalityName: b[`gdename_${this.context}`],
                    result: +b[o.key]
                  }
                ]
              } else return a
            }, [])
          })
        })

        //

        data.forEach(o => {
          console.log(o.objectNumber)
          console.log(
            o.data.sort((a, b) =>
              a.result > b.result ? 1 : b.result > a.result ? -1 : 0
            )
          )
        })

        //

        return new Promise(resolve => {
          resolve(data)
        }) as Promise<{ objectNumber: number; data: Municipality[] }[]>
      })
      .catch(e => {
        console.log(e)
      })
  }

  /**
   * Find the title from the received text
   * @param text
   */
  extractTitle(text: string) {
    const titleRe = /<h4.*?>(.*?)(<br>|<\/h4>)/g
    const match = titleRe.exec(text)
    if (match && match[1]) {
      return match[1]
    } else {
      return LOCALES.title[this.context]
    }
  }

  /**
   * Clean up the received text
   * @param text
   */
  cleanText(text: string) {
    console.log(text)
    // Some more cleaning
    text = text.replace(/<br>((\s)*<br>)+/g, '<br><br>')
    text = text.replace(/^(<br>)+|(<br>)+$/g, '')
    text = text.replace(/<\/h4>(\s)*(<br>)+/g, '</h4>')

    // Extract the results table
    const reTable = new RegExp(/{.*}/, 'gmi')
    const table = text.match(reTable)
    text = text.replace(reTable, '')

    if (table) {
      this.setState({
        resultsTable: table[0]
      })
    }

    console.log(table)

    return text
  }

  /**
   * Split the received text according to custom tags.
   * Also need the results to construct the chart module.
   * @param text
   * @param results
   */
  splitText(
    text: string,
    results: Array<{ objectNumber: number; data: Municipality[] }>
  ) {
    // Extract the results table
    const reTable = new RegExp(/{.*}/, 'gmi')
    const table = text.match(reTable)
    const rawText = text.replace(reTable, '')

    // Find the modules to add in the text
    const modulesMatchResult = rawText.match(/#MODULE:.*?#/gi)
    const modules = new Array<{ type: string; element: JSX.Element }>()

    // If there is modules tags in the text
    if (modulesMatchResult) {
      modulesMatchResult.forEach(t => {
        // Find the type of module
        const typeMatch = t.match(/#MODULE:(.*)?\(/)

        if (typeMatch) {
          const params = t.match(/\((.*?)\)/)
          let paramsList = new Array<string>()
          const type = typeMatch[1].toLowerCase()

          if (params) {
            paramsList = params[1].split(',')
            paramsList[0] = paramsList[0].toLowerCase()
          }

          const objectData = results.find(
            o => o.objectNumber === +paramsList[1]
          )

          // Add a new module according to the type
          switch (type) {
            case 'table':
              // If we don't have the data, then don't add the table
              if (table) {
                modules.push({
                  type: 'table',
                  element: (
                    <VotationResultsTable
                      chartData={objectData ? objectData.data : null}
                      municipalityNumber={this.props.municipalityId}
                      table={table[0]}
                      showOnly={paramsList}
                    />
                  )
                })
              }
              break
            case 'teasers':
              modules.push({
                type: 'teasers',
                element: (
                  <ArticleTeasers
                    className='mini-teasers'
                    numberOfCards='one'
                    articleIds={paramsList}
                  />
                )
              })
              break
          }
        }
      })
    }

    // Split the text into the same number of modules it contains
    // We want to show a module after each of these text sections
    const t = rawText.split('#CANTON#')
    let cantonalTexts = []
    const federalTexts = t[0].split(/#MODULE.*?#/) || []
    if (t.length > 1) {
      cantonalTexts = t[1].split(/#MODULE.*?#/)
      cantonalTexts.forEach((t, i) => (cantonalTexts[i] = this.cleanText(t)))
    }

    // Clean the text by replacing <br> by paragraphs and removing unnecessary breaklines
    federalTexts.forEach((t, i) => (federalTexts[i] = this.cleanText(t)))

    console.log(federalTexts, cantonalTexts, modules)

    return {
      texts: {
        federal: federalTexts,
        cantonal: cantonalTexts
      },
      modules: modules,
      rawText: rawText
    }
  }

  componentDidMount() {
    this.getVoteText(this.props.municipalityId, this.context)
      .then((data: VoteBackendResponse) => {
        this.setState({
          articleText: this.cleanText(data.content),
          errorMessage: null
        })
      })
      .catch(e => this.handleError(e))
  }

  componentDidUpdate(prevProps: Props): void {
    if (
      prevProps.municipalityId !== this.props.municipalityId ||
      this.currentLocale !== this.context
    ) {
      // make sure that we save the new locale
      this.currentLocale = this.context

      this.getVoteText(this.props.municipalityId, this.context)
        .then((data: VoteBackendResponse) => {
          this.setState({
            articleText: this.cleanText(data.content),
            errorMessage: null
          })
        })
        .catch(e => this.handleError(e))
    }
  }

  render() {
    const containerClasses = 'step article'
    const textSliceIndex = 0

    const Search = (
      <aside className='ui secondary grey segment'>
        <h4 className='ui tiny header'>
          {LOCALES.municipalitySearchBoxTitle[this.context]}
        </h4>
        <MunicipalitySearch
          locale={this.context}
          municipalityData='2019'
          onSelectionHandler={this.props.onMunicipalitySelection}
        />
      </aside>
    )

    // Setup content for the default case
    let Content = (
      <div className={styles.railContainer}>
        {/* <h3 className='ui header'>{t('boxTitle')}:</h3> */}
        {this.state.articleText && (
          <>
            <div
              dangerouslySetInnerHTML={{
                __html: this.state.articleText ?? ''
              }}
            />
            <VotationResultsTable table={this.state.resultsTable} />
          </>
        )}
        {!this.state.articleText && (
          <div className='ui placeholder'>
            <div className='header'>
              <div className='line' />
              <div className='line' />
            </div>
            <div className='paragraph'>
              <div className='line' />
              <div className='line' />
              <div className='line' />
              <div className='line' />
              <div className='line' />
              <div className='line' />
              <div className='line' />
            </div>
            <div className='paragraph'>
              <div className='line' />
              <div className='line' />
              <div className='line' />
              <div className='line' />
              <div className='line' />
            </div>
            <div className='paragraph'>
              <div className='line' />
              <div className='line' />
              <div className='line' />
            </div>
          </div>
        )}
        {/* <a
            href={`https://${t('dashboardPrefix')}.${
              parseHostname().publicationDomain
            }/2019-05-19`}
            className='ui bottom attached orange button'
          >
            {t('dashboardButton')}
            <i className='arrow circle right icon' />
          </a> */}
        <aside
          className={`${clsx(styles.rail)} ${
            this.state.texts.cantonal.length <= 1 &&
            this.state.texts.federal.length <= 1
              ? clsx(styles.railMobile)
              : ''
          }`}
          style={{
            top: `${
              this.state.texts.cantonal.length > 1 &&
              this.state.texts.federal.length > 1
                ? '8rem'
                : 0
            }`
          }}
        >
          <a
            className={clsx(styles.dashboardLink)}
            href={`https://${LOCALES.dashboardPrefix[this.context]}.${
              parseHostname().publicationDomain
            }/2020-02-09`}
          >
            <img alt='' src={require('./votationHub.jpg')} />
            <div className={clsx(styles.dashboardLinkContent)}>
              <span className='abo'>Abo</span>
              <small>{LOCALES.votationLinkSup[this.context]}</small>
              <div>{LOCALES.votationLink[this.context]}</div>
            </div>
          </a>
        </aside>
      </div>
    )

    // show something else in case of an error
    if (this.state.errorMessage) {
      Content = (
        <div className='ui text container'>
          <FetchErrorMessage
            status={this.state.errorMessage ?? ''}
            locale={this.context}
          />
        </div>
      )
    }

    return (
      <>
        <header className='ui vertical  very fitted  segment'>
          <div className='ui container'>
            <div className='ui header'>
              <h1>{this.state.title}</h1>
              <h2>{LOCALES.lead[this.context]}</h2>
            </div>
          </div>
        </header>
        <ScrollToTopOnMount />
        <div
          className='ui vertical padded segment'
          // id='main-content'
          style={{ paddingBottom: 0 }}
        >
          <div className='ui text container'>
            <div className={containerClasses} style={{ zIndex: 10 }}>
              {Content}
            </div>
          </div>
        </div>
        <div
          className='ui vertical colored padded segment'
          style={{ marginTop: '3rem' }}
        >
          <div className='ui text container'>{Search}</div>
        </div>
      </>
    )
  }
}
